import type {RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import cn from 'classnames'
import Link from 'next/link'
import {linkResolver} from 'prismicio'
import type {Control, FieldPath, FieldValues} from 'react-hook-form'
import {Controller} from 'react-hook-form'
import {MossUICheckbox, MossUIField} from './MossUiComponents'

const textSizes = {
  small: 'text-10 leading-4 lg:text-body-s',
  medium: 'text-16 leading-5 tracking-[0.16px]',
}

export function PrivacyCheckbox<T extends FieldValues = FieldValues>({
  control,
  name,
  label,
  textSize = 'medium',
  textColor = 'text-grey-110',
  linkColor = 'text-grey-110',
}: {
  control: Control<T>
  name: FieldPath<T>
  label: RichTextField
  textSize?: 'small' | 'medium' | 'x-small'
  textColor?: string
  linkColor?: string
}) {
  return (
    <div className="col-span-full">
      <MossUIField>
        <Controller
          control={control}
          name={name}
          rules={{required: true}}
          render={({field}) => (
            <MossUICheckbox onChange={(e) => field.onChange((e.target as HTMLInputElement).checked)}>
              <PrismicRichText
                field={label}
                components={{
                  paragraph: ({children}) => (
                    <p
                      className={cn(`${textColor}`, {
                        [textSizes.small]: textSize === 'small',
                        [textSizes.medium]: textSize === 'medium',
                        'text-body-xs': textSize === 'x-small',
                      })}
                    >
                      {children}
                    </p>
                  ),
                  hyperlink: ({node, children}) => (
                    <Link
                      className={cn(
                        `${linkColor} underline underline-offset-2 transition-colors hover:text-grey-110/[80%]`,
                        {
                          [textSizes.small]: textSize === 'small',
                          [textSizes.medium]: textSize === 'medium',
                        },
                      )}
                      href={linkResolver(node.data)}
                      {...(isFilled.link(node.data) && node.data.link_type === 'Web' && {target: node.data.target})}
                    >
                      {children}
                    </Link>
                  ),
                }}
              />
            </MossUICheckbox>
          )}
        />
      </MossUIField>
    </div>
  )
}
